import React from "react";
import App from "../App";

import Appointments from "./New1";
import Userfeedback from "./Userfeedback";

export default function ServicesPage() {
  return (
    <>
     <Appointments></Appointments>
     <Userfeedback></Userfeedback>
    </>
  );
}